import { useState } from "react";
import { Accordion, Nav } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function T8_projects_mnu({permission, setactivity, activeItem, project_management, ies_management}) {
  const [isProductionOpen, setProductionOpen] = useState(true); // Predeterminadamente abierto
  const navigate = useNavigate();
  const activeStyles = { fontWeight: 600, backgroundColor: '#e7f1ff', color: '#0d6efd' };
  const hasProjectAccess = project_management && String(project_management) !== '0';
  const iesLevel = parseInt(ies_management, 10) || 0;
  return (
    <Accordion.Item eventKey="3">
    <Accordion.Header>
      <span role="img" aria-label="projects">🏨</span> Observatorio Educativo
    </Accordion.Header>
    <Accordion.Body className="p-0">
      <Nav className="flex-column">
        {hasProjectAccess && (
          <Nav.Link active={activeItem === 'projects_relations'} style={activeItem === 'projects_relations' ? activeStyles : undefined} onClick={() => navigate('/Projects_relations')}>Dashboards</Nav.Link>
        )}
        {iesLevel >= 1 && (
          <Nav.Link active={activeItem === 'instituciones'} style={activeItem === 'instituciones' ? activeStyles : undefined} onClick={() => navigate('/instituciones')}>Instituciones</Nav.Link>
        )}
        {permission === '1' && (
          <Nav.Link active={activeItem === 'mass_messaging'} style={activeItem === 'mass_messaging' ? activeStyles : undefined} onClick={() => navigate('/MassMessaging')}>Mensajería masiva</Nav.Link>
        )}
      </Nav>
    </Accordion.Body>
  </Accordion.Item>
  );
}

export default T8_projects_mnu;
